import { render, staticRenderFns } from "./RibbonItem.vue?vue&type=template&id=70d17a04&scoped=true&functional=true&"
import script from "./RibbonItem.vue?vue&type=script&lang=js&"
export * from "./RibbonItem.vue?vue&type=script&lang=js&"
import style0 from "./RibbonItem.vue?vue&type=style&index=0&id=70d17a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "70d17a04",
  null
  
)

export default component.exports